import {
  Box,
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
} from "@mui/material";

const HeaderCupomDesconto = ({ cupomValido, buscarCupomValido }) => {
  return (
    <Box
      sx={{
        paddingTop: "1rem",
        paddingLeft: "2rem",
        display: "flex",
        gap: "1rem",
        flexDirection: "row",
        alignItems: "center",
      }}
    >
      <FormLabel style={{ color: "primary" }}> Filtrar por: </FormLabel>
      <FormControl component="fieldset">
        <RadioGroup
          row
          name="filtroValido"
          value={cupomValido}
          onChange={() => buscarCupomValido()}
        >
          <FormControlLabel value={true} control={<Radio />} label="Válidos" />
          <FormControlLabel value={false} control={<Radio />} label="Todos" />
        </RadioGroup>
      </FormControl>
    </Box>
  );
};

export default HeaderCupomDesconto;
